import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import TrainerContext from "../context/trainerContext/TrainerContext";
import { isAccessAllowed } from "../utils/helpers";

const ProtectedRoute = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const { getTrainerState } = useContext(TrainerContext);
  const isAuthenticated = getTrainerState()?.token !== "";
  const trainerIsAdmin = getTrainerState()?.trainerIsAdmin;

  if (isAuthenticated && !trainerIsAdmin && pathname.startsWith("/admin")) {
    return <Navigate to="/" />;
  }

  if (
    (pathname.includes("/meal-plan") && !isAccessAllowed("MEAL_PLAN_VIEW")) ||
    (pathname.includes("/reports") && !isAccessAllowed("REPORT_VIEW")) ||
    (pathname.includes("/reports/add") && !isAccessAllowed("REPORT_ADD")) ||
    (pathname.includes("/notes") && !isAccessAllowed("NOTES_VIEW")) ||
    (pathname.includes("/sessions") &&
      !isAccessAllowed("USER_SESSIONS_VIEW")) ||
    (pathname.includes("/prescriptions") &&
      !isAccessAllowed("PRESCRIPTION_VIEW")) ||
    (pathname.includes("/prescriptions/add") &&
      !isAccessAllowed("PRESCRIPTION_ADD")) ||
    (pathname.includes("/trainers/slots") &&
      !isAccessAllowed("MANAGE_TRAINER_SLOTS")) ||
    (pathname.includes("/trainers/sessions") &&
      !isAccessAllowed("MANAGE_TRAINER_SESSIONS")) ||
    (pathname.includes("/assessments") && !isAccessAllowed("ASSESSMENT_VIEW"))
  ) {
    return <Navigate to="/" />;
  }

  return <>{isAuthenticated ? <Outlet /> : <Navigate to="/login" />}</>;
};

export default ProtectedRoute;
